import { ComponentProps, ReactNode } from 'react';
import { ToggleButton as AriaToggleButton } from 'react-aria-components';
import { Typography } from '../../atoms/typography/typography';
import { twMerge } from 'tailwind-merge';

type Props = {
  children: ReactNode;
  className?: string;
  isSelected?: boolean;
} & Omit<ComponentProps<typeof AriaToggleButton>, 'children' | 'className'>;

export function ToggleButton(props: Props) {
  const { children, className, isSelected, ...rest } = props;

  return (
    <AriaToggleButton
      isSelected={isSelected}
      className={twMerge(
        'bg-grayscale0',
        'border-2',
        'border-primaryMain',
        'rounded-6',
        'text-primaryMain',
        'leading-1',
        'p-8',
        'hover:bg-primary50',
        'hover:border-primary400',
        'hover:text-primary400',
        'active:bg-primary100',
        'active:border-primary600',
        'active:text-primary600',
        'data-[selected="true"]:bg-success50',
        'data-[selected="true"]:border-success300',
        'data-[selected="true"]:text-success300',
        'data-[selected="true"]:hover:bg-success50',
        'data-[selected="true"]:hover:border-success400',
        'data-[selected="true"]:hover:text-success400',
        className,
      )}
      {...rest}
    >
      <Typography
        variant="body-s"
        weight="medium"
        useCase="button"
        className="text-currentColor"
      >
        {children}
      </Typography>
    </AriaToggleButton>
  );
}
